export default __webpack_public_path__ + "static/media/peach-granola.cb7e407d.jpg";